"use strict";
var ApiBenefit = (function () {
    function ApiBenefit() {
    }
    return ApiBenefit;
}());
exports.ApiBenefit = ApiBenefit;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-benefit.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-benefit.model.js